export enum ShareIconType {
  Facebook = "facebook",
  Linkedin = "linkedin",
  Pinterest = "pinterest",
  Reddit = "reddit",
  Twitter = "twitter",
  Email = "email"
}